import { type ReactNode } from 'react'
import { Clock, Mail } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { AutomationPlatform } from '@backend/lib/db/schema/automation'
import { StarsIcon } from '@/components/ui/icons/icons-new'
import { PlatformIcons } from './platform-icon'

const ICON_CLASS = 'h-3.5 w-3.5 text-muted-foreground'

interface FlowChipProps {
  children: ReactNode
  muted?: boolean
}

export function FlowChip({ children, muted }: FlowChipProps) {
  return (
    <span
      className={cn(
        'border-border bg-background text-foreground inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium',
        muted && 'text-muted-foreground border-dashed bg-transparent',
      )}>
      {children}
    </span>
  )
}

export function FlowConnector({ muted }: { muted?: boolean }) {
  return <span aria-hidden className={cn('bg-border h-px w-3 shrink-0', muted && 'bg-border/60')} />
}

interface FlowRailProps {
  platforms: AutomationPlatform[]
  muted?: boolean
}

/** `[Clock] 8:00 → [Stars] Generate post + platforms → [Mail] Email you` */
export function FlowRail({ platforms, muted }: FlowRailProps) {
  return (
    <div className="scrollbar-hide flex min-w-0 items-center overflow-x-auto">
      <FlowChip muted={muted}>
        <Clock className={ICON_CLASS} />
        8:00
      </FlowChip>
      <FlowConnector muted={muted} />
      <FlowChip muted={muted}>
        <StarsIcon
          width={14}
          height={14}
          color={muted ? 'var(--muted-foreground)' : 'var(--foreground)'}
        />
        Generate post
        <PlatformIcons platforms={platforms} size="xs" />
      </FlowChip>
      <FlowConnector muted={muted} />
      <FlowChip muted={muted}>
        <Mail className={ICON_CLASS} />
        Email you
      </FlowChip>
    </div>
  )
}
